import { Pipe, PipeTransform } from '@angular/core';
import { IDenialTypeInfo } from 'app/core/services/mainapp/multiplePathways';

@Pipe({ name: 'denialTypes' })

export class DenialTypesPipe implements PipeTransform {
    transform(value: number | null | undefined, dtypes: IDenialTypeInfo[]) {
        if (value == null) return '';
        if (!dtypes || !dtypes.length) return value;

        const dtype = dtypes.filter(d => d.DenialTypeID === value)[0];

        return (dtype && dtype.Description) || value;
    }
}